import React from 'react';
import { Link } from 'react-router-dom';
import PageHead from '../general/PageHead';
import '../styles/staff/Staff.css';

const TEAMS = [
  {
    leader: { id: 100, name: 'Travis Cromack' },
    members: [
      { id: 108, name: 'Kelly Rommel' },
      { id: 171, name: 'Scott Weiss' },
      { id: 69,  name: 'Patrick Sampson' },
      { id: 97,  name: 'Joshua Herbst' },
      { id: 105, name: 'John Cole' },
      { id: 155, name: 'Kionna Owens' },
      { id: 175, name: 'Kurt Comisky' },
      { id: 2,   name: 'Jason Wells' },
    ],
  },
  {
    leader: { id: 148, name: 'Chuck Paris' },
    members: [
      { id: 74,  name: 'Tricia Johnson' },
      { id: 151, name: 'Christopher Sugar' },
      { id: 146, name: 'Cherlyn Poindexter' },
      { id: 123, name: 'Paul Lavallee' },
      { id: 126, name: 'Ed Perez' },
      { id: 154, name: 'Meagan Balducci' },
    ],
  },
  {
    leader: { id: 120, name: 'John DeVito' },
    members: [
      { id: 156, name: 'Gary Brochu' },
      { id: 60,  name: 'Anthony Bento' },
      { id: 130, name: 'Lorin Raccuia' },
      { id: 103, name: 'Rob Montuori' },
      { id: 113, name: 'Tricia Santos' },
      { id: 159, name: 'James Ferraro' },
    ],
  },
  {
    leader: { id: 2, name: 'Jason Wells' },
    members: [
      { id: 4,   name: 'Neil Cunningham' },
      { id: 93,  name: 'Heather Longo' },
      { id: 27,  name: 'Bonnie Liedtke' },
      { id: 102, name: 'Luke Leone' },
      { id: 135, name: 'Rudy Demiraj' },
      { id: 167, name: 'Rob Raczka' },
      { id: 169, name: 'Collin Provost' },
    ],
  },
];

function initials(name) {
  if (!name) return '?';
  return name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();
}

function TeamCard({ team }) {
  return (
    <div className="card" style={{ overflow: 'hidden' }}>
      <div className="coord-card-head">
        <div className="avatar">{initials(team.leader.name)}</div>
        <Link
          to={`/employee/${team.leader.id}`}
          style={{ color: 'inherit', textDecoration: 'none', fontWeight: 600 }}
        >
          {team.leader.name}
        </Link>
      </div>
      <div className="coord-list">
        {team.members.map(member => (
          <Link
            key={member.id}
            to={`/employee/${member.id}`}
            className="item"
            style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}
          >
            <div className="avatar-mini">{initials(member.name)}</div>
            <span style={{ fontSize: 13.5, color: 'var(--fg-1)' }}>{member.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

function AreaCoordinators() {
  return (
    <>
      <PageHead title="Area Coordinators" sub="Field coordinator teams" />
      <div className="grid-4 staff-grid">
        {TEAMS.map(team => (
          <TeamCard key={team.leader.id} team={team} />
        ))}
      </div>
    </>
  );
}

export default AreaCoordinators;
